import React from 'react';

import DateBox from 'devextreme-react/date-box';
import Validator, { RequiredRule } from 'devextreme-react/validator';

type FormDateBoxProps = {
  value: Date | string | number | null,
  readOnly: boolean,
  name: string,
  label?: string,
  onValueChange: (value: Date | string | number | null) => void,
  stylingMode?: 'filled' | 'outlined' | 'underlined',
};

export const FormDateBox = ({
  value,
  readOnly,
  name,
  label,
  onValueChange,
  stylingMode = 'filled'
}: FormDateBoxProps) => {
  return (
    <DateBox
      value={value}
      readOnly={readOnly}
      name={name}
      label={label}
      inputAttr={{ class: 'form-editor-input' }}
      stylingMode={stylingMode}
      placeholder='MM/dd/y'
      displayFormat='MM/dd/y'
      onValueChange={onValueChange}
    >
      <Validator>
        <RequiredRule />
      </Validator>
    </DateBox>
  );
};
